import { createWebHistory, createRouter } from "vue-router";
import routes from './routes';

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0, left: 0 };
    }
  },
});

// Auth guard
router.beforeEach((to, from, next) => {
  const isMaintenanceMode = process.env.VUE_APP_MAINTENANCE_MODE === 'true';
  if (isMaintenanceMode && to.name !== 'maintenance') {
    return next({ name: 'maintenance' });
  }

  const token = localStorage.getItem('admin_token');
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const isGuest = to.meta.guest;

  if (requiresAuth && !token) {
    next({ path: '/login', query: { redirect: to.fullPath } });
  } else if (isGuest && token) {
    next('/');
  } else {
    next();
  }
});

// Set page title
router.afterEach((to) => {
  const title = to.meta.title || 'Dashboard';
  document.title = `${title} | ${process.env.VUE_APP_NAME || 'Molnz Admin'}`;
});

export default router;
